import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import PopUp from '../../../../Shared/Popup/PopUp';
import PriceItemList from '../PriceItemList/PriceItemList';
import PriceItemListCellular from '../PriceItemList/PriceItemListCellular';
import {reportDWH, setIsShoppingCartOpen} from '../../saleJetBlockSlice';
import './ShoppingCart.scss';

const ShoppingCart = (props) => {
  const [hasContent, setHasContent] = useState(false);
  const isOpen = props.isShoppingCartOpen;
  const isPackageDetailsMode = props.shoppingCartPopupMode === 'packageDetails';
  const popupTitle = isPackageDetailsMode ? props.packageName : 'מה היה לנו עד עכשיו?';
  const popupButtonText = isPackageDetailsMode ? 'הבנתי, תודה' : 'המשך תשלום';

  useEffect(() => {
    if (Object.keys(props.summaryDetails).length > 0) {
      setHasContent(true);
    } else {
      setHasContent(false);
    }
  }, [props.summaryDetails]);

  return (
    <div className='shopping-cart-wrapper'>
      {props.isDisplayShoppingCart && (
        props.isLoadingShoppingCart ? (
          <div className='loader'></div>
        ) : (
          hasContent && (
            <button className={`cart-icon ${isOpen ? 'cart-open' : ''}`} onClick={() => handleIsOpen()}>
              <Image src={require('./images/cart-icon-black.svg')} />
              <div className='products-count'>{props.summaryDetails.productsCount}</div>
            </button>
          )
        )
      )}
      <PopUp
        className={`popup-shopping-cart ${isPackageDetailsMode ? 'popup-shopping-cart--package-details' : ''}`}
        showPopUp={isOpen}
        onClose={() => {
          handleCartClose();
        }}>
        <div className='shopping-cart'>
          <h1>{popupTitle}</h1>
          {props.summaryDetails.saleType == 'cellular' ? (
            <PriceItemListCellular summaryDetails={props.summaryDetails} closeShoppingCartPopUp={() => props.setIsShoppingCartOpen(false)} />
          ) : (
            <PriceItemList summaryDetails={props.summaryDetails} />
          )}
          <div className='btns-wrapper'>
            <BtnSubmit text={popupButtonText} onclick={handleOnClickBtn} />
          </div>
        </div>
      </PopUp>
    </div>
  );

  function handleCartClose() {
    props.setIsShoppingCartOpen(false);
  }

  function handleIsOpen() {
    if (!props.summaryDetails) {
      return;
    }
    const nextIsOpen = !isOpen;
    props.setIsShoppingCartOpen(nextIsOpen);
    if (nextIsOpen) {
      props.reportDWH({actionType: 'Cart', status: 'Ongoing', messageText: 'Open Shopping Cart'});
      props.reportDWH({actionType: 'Cart', status: 'Ongoing', messageText: 'Shopping Cart Displayed'});
    }
  }

  function handleOnClickBtn() {
    props.setIsShoppingCartOpen(false);
    props.reportDWH({actionType: 'Cart', status: 'Ongoing', messageText: 'Shopping Cart button Clicked'});
  }
};

const mapStateToProps = (state) => {
  return {
    summaryDetails: state.saleJetBlock.summaryDetails,
    isLoadingShoppingCart: state.saleJetBlock.isLoadingShoppingCart,
    isDisplayShoppingCart: state.saleJetBlock.isDisplayShoppingCart,
    isShoppingCartOpen: state.saleJetBlock.isShoppingCartOpen,
    shoppingCartPopupMode: state.saleJetBlock.shoppingCartPopupMode,
    packageName: state.saleJetBlock.selectedPackage?.title,
  };
};
const mapDispatchToProps = {reportDWH, setIsShoppingCartOpen};
export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCart);
